<template>
    <div>
        <el-row>
            <el-form>
                <el-form-item label="展示方式：">
                    <el-radio-group v-model="displayMode">
                        <el-radio :label="1">平铺</el-radio>
                        <el-radio :label="2">分组</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
        </el-row>
        <data-table v-if="displayMode == 1"/>
        <data-group v-else/>
    </div>
</template>
<script>
import { Loading } from "element-ui";
import DataGroup from "./DataGroup"
import DataTable from "./DataTable"
export default {
    components: {DataGroup, DataTable},
    data: vm=>({
        displayMode: 1,
        groupId: null,
        groupList: [], //分组列表
        listData: [], //数据列表
    }),
    created(){
        // this.getGroupList()
        this.getDatas()
    },
    methods: {
        getGroupList(){
            this.$axios.get( url )
                .then(({ data: { msg, data, code } }) => {
                    if (code == 20000) {
                        this.groupList = data
                    } else {
                        this.$message({ showClose: true, message: msg, type: "error" });
                        console.log(msg);
                    }
                    loading.close();
                })
                .catch(err => {
                    console.log(err)
                    loading.close();
                });
        },
        getDatas(){
            let loading = Loading.service({
                fullscreen: true,
                text: "数据加载中..."
            });
            this.listData = [];
            const url = this.baseUrl3 + 'analyses/get/show/list'
            this.$axios.get( url )
                .then(({ data: { msg, data, code } }) => {
                    if (code == 20000) {
                        this.listData = data.urls
                    } else {
                        this.$message({ showClose: true, message: msg, type: "error" });
                        console.log(msg);
                    }
                    loading.close();
                })
                .catch(err => {
                    console.log(err)
                    loading.close();
                });
        },
    }
}
</script>
